import { createContext, useState } from 'react';
import {
  node, string, oneOfType, bool,
} from 'prop-types';
import InternalErrorPage from 'pages/500';

const FallbackUI = ({ message }) => (
  <div>
    <h2>An error ocurred!</h2>
    <h4>{message}</h4>
  </div>
);

FallbackUI.propTypes = {
  message: string.isRequired,
};

export const errorContext = createContext();

const ErrorProvider = ({ error, children }) => {
  const [ localError, setLocalError ] = useState(false);

  const spreadError = (message, toast) => {
    // para errores que React no detecta
    console.error('React Error in Client  => ', message.toString());
    setLocalError(message.toString());
  };

  const firstChildDisplayName = children[0]?.type?.displayName;

  if (error === false && localError === false && firstChildDisplayName !== 'ErrorPage') {
    try {
      return <errorContext.Provider value={{ spreadError }}>
        { children }
      </errorContext.Provider>;
    } catch (e) {
      return <InternalErrorPage />;
    }
  }
  return <InternalErrorPage />;
};

ErrorProvider.propTypes = {
  children: node,
  error: oneOfType([ string, bool ]),
};

export default ErrorProvider;
